<template>
  <div class="field boolean">
    <span v-if="label" class="label text-right" :class="labelClass">
      {{ label }}
    </span>

    <div class="value v-align":class="valueClass">
      <b-badge :class="badgeClass">
        {{ $t(text) }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import bBadge from 'bootstrap-vue/es/components/badge/badge'

export default {
  components: {
    bBadge
  },

  props: {
    value: {
      type: [String, Boolean, Number]
    },
    label: String,
    width: String
  },

  data: function () {
    return {
      text: null,
      falseValues: ['false', 'f', 'no', 'non', '0']
    }
  },

  created: function () {
    if (typeof this.value === 'number') {
       this.text = this.value > 0 ? 'OK' : 'Error'
    } else {
      if (!this.value || this.falseValues.indexOf(this.value) !== -1) {
        this.text = '_no'
      } else {
        this.text = '_yes'
      }
    }
  },

  computed: {
    valueClass: function () {
      if (this.label) {
        return 'col-8'
      }
    },

    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    },

    badgeClass: function () {
      if (typeof this.value === 'number') {
        return this.value > 0 ? 'bg-success' : 'bg-danger'
      }

      return this.value ? 'bg-success' : 'bg-danger'
    }
  }
}
</script>
